import { index, uniqueIndex } from '@w/db'
import { enumValues, sqliteTable } from '@w/db/sqlite'
import { productTables } from './product-tables'
export * from './product-tables'
export const workspaceMembershipRoleCodes = { admin: 0, member: 1, teacher: 2 } as const
export const workspaceMembershipRoleValues = enumValues(workspaceMembershipRoleCodes)

export const workspaces = sqliteTable({
  columns: (c) => ({
    id: c.ulid().notNull().primaryKey(),
    name: c.text().notNull().comment('User-visible workspace name'),
    updatedAt: c.datetime().notNull(),
  }),
  fn: () => ({
    secure: () => true,
  }),
})

export const workspaceMemberships = sqliteTable({
  columns: (c) => ({
    id: c.ulid().notNull().primaryKey(),
    userId: c.ulid().notNull(),
    workspaceId: c.ulid().notNull(),
    role: c.enum(workspaceMembershipRoleCodes).notNull().default('member'),
  }),
  indexes: (t) => [
    index(t.userId),
    index(t.workspaceId),
    uniqueIndex(t.userId, t.workspaceId),
  ],
  fn: () => ({
    secure: () => true,
  }),
})
export const invites = sqliteTable({
  columns: (c) => ({
    id: c.ulid().notNull().primaryKey(),
    workspaceId: c.ulid().notNull().references(() => workspaces.id),
    pageId: c.text(),
    level: c.integer(),
    recipientUserId: c.ulid().notNull(),
    createdByUserId: c.ulid().notNull(),
  }),
  indexes: t => [index(t.recipientUserId), index(t.createdByUserId)],
  fn: () => ({ secure: () => true }),
})

/**
 * Each member's personal root page in a workspace (db-crdt-sync.spec.md :uc[root-pages-have-ulid-ids]): the server mints
 * the page id once, when it creates the root, and never changes or deletes the row; leaving a workspace keeps it, so a
 * rejoin reuses the same root. `workspace.list` carries it as the caller's `personalRootId`.
 */
export const personalRoots = sqliteTable({
  columns: (c) => ({
    workspaceId: c.ulid().notNull(),
    userId: c.ulid().notNull(),
    // Text like `pages.id`, which it names.
    pageId: c.text().notNull(),
  }),
  primaryKey: (t) => [t.workspaceId, t.userId],
  fn: () => ({
    secure: () => true,
  }),
})
export const directoryTables = { workspaces, workspaceMemberships, invites, personalRoots, ...productTables }
export type DirectoryInvite = typeof invites.__selectType
export type DirectoryInviteInsert = typeof invites.__insertType

export type Workspace = typeof workspaces.__selectType
export type WorkspaceInsert = typeof workspaces.__insertType
export type WorkspaceMembership = typeof workspaceMemberships.__selectType
export type WorkspaceMembershipInsert = typeof workspaceMemberships.__insertType
